import styled from "@emotion/styled/macro";
import { flexCenter, flexColumn } from "../../../../common/styles/combos.styles";
import { colors, shadows, views } from "../../../../common/styles/theme.styles";

export const DeepAnalysisSuccessModalContent = styled.div`
  ${flexColumn};
  justify-content: center;
  flex:1;
  width: 100%;
  border-top: 1px solid ${colors.lightGray2};
  border-bottom: 1px solid ${colors.lightGray2};
  padding: 40px 108px 48px 108px;

  .ant-input {
    border: 1px solid ${colors.gray3};
    border-radius: 8px;
  }

  .ant-input:focus, .ant-input-focused {
    border-color: ${colors.darkGray1};
    box-shadow: none;
  }

  overflow-y: auto;
`;

export const DeepAnalysisSuccessModalFooter = styled.div`
  ${flexCenter};
  justify-content: space-between;
  padding: 16px 24px;

  ${({ isMobile }) => isMobile && `
    flex-direction: column;
    gap: 16px;
  `}
`;

export const ActionLinkButton = styled.a`
    ${flexCenter};
    gap: 8px;
    width: ${props => props.width ? props.width : 'auto'};
    box-shadow: ${shadows.tagsShadow};
    border-radius: 8px;
    padding:${props => props.withIcon ? '8px 40px 8px 32px' : '8px 40px'};
    font-size:16px;
    font-weight: 450;
    color: ${colors.darkGray1};
    :hover {
        color: ${colors.darkGray1};
    }
    cursor: pointer;
    .anticon{
        padding:0 8px 0 0;
    }
    ${props => props.disabled ? `opacity:0.6;cursor:default` : ``}
    svg{
        width: 24px;
        height: 24px;
    }
`;

export const FileDropArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 100%;
    ${views.tablet}{
        width: 80%;
        gap: 12px;
    }
`;

export const PromptWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
`;

export const AltTextPrompt = styled.div`
    color: ${colors.darkGray3};
    font-size: 14px;
    font-weight: 450;
    line-height: 130%;
    text-align: center;
`;

export const MainTextPrompt = styled(AltTextPrompt)`
    color: ${colors.darkGray1};
    font-size: 16px;
    font-weight: 500;
`;

export const LighterMainTextPrompt = styled(MainTextPrompt)`
    font-weight: 450;
    font-size: 14px;
    padding-top: 4px;
`;

export const WrongFileContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;
    align-items: center;
    justify-content: center;
    flex: 1;
`;